export const pl = {
    translation: {
        b: {
            cancel: 'Anuluj',
            confirm: 'Potwierdź',
            send: 'Wyślij',
            done: 'Gotowe',
            close: 'Zamknij',
            clear: 'Wyczyść',
            copy_link: 'Kopiuj link',
            export: 'Eksportuj',
            delete: 'Usuń',
            delete_confirm: 'Potwierdź usunięcie',
            duplicate: 'Duplikuj',
            share: 'Udostępnij',
            sign_in: 'Zaloguj się',
            sign_up: 'Zarejestruj się',
            email_address: 'Adres e-mail',
            yes: 'Tak',
            no: 'Nie',
            back: 'Wstecz',
            upgrade: 'Ulepsz',
            remove: 'Usuń',
            restore: 'Przywróć',
            archive: 'Archiwizuj',
            rename: 'Zmień nazwę',
            leave: 'Opuść',
            import: 'Importuj',
            continue: 'Kontynuuj',
            settings: 'Ustawienia',
            log_out: 'Wyloguj się',
            invite: 'Zaproś',
            invited: 'Zaproszony',
        },
        roles: {
            view: 'Przeglądający',
            comment: 'Komentujący',
            edit: 'Edytor',
            admin: 'Administrator',
            owner: 'Właściciel',
            member: 'Członek',
            remove: 'Usuń',
            more_roles: 'Więcej ról...',
            change_role: 'Zmień rolę...',
            remove_access: 'Usuń dostęp...',
            remove_invite: 'Usuń zaproszenie...',
        },
        db_engine: {
            basic: 'Podstawowy SQL',
            general: 'Ogólny SQL',
        },
        socket_status: {
            reconnecting: 'Ponowne łączenie...',
            offline: 'Jesteś offline. Ponowne łączenie...',
        },
        loader: {
            diagram: 'Ładowanie diagramu...',
        },
        m_languages: {
            title: 'Języki',
            subtitle: 'Wybierz język'
        },
        m_feedback: {
            feature: {
                name: 'Prośba o funkcję',
                desc: 'Brakuje funkcji, której potrzebujesz? Daj nam znać — Twoje pomysły są ważne'
            },
            feedback: {
                name: 'Podziel się opinią',
                desc: 'Chętnie poznamy Twoje zdanie'
            },
            support: {
                name: 'Wsparcie',
                desc: 'Coś nie działa? Daj nam znać — szybko to naprawimy',
            },
            bug: {
                name: 'Zgłoś problem',
                desc: 'Coś jest nie tak? Zgłoś to — szybko się tym zajmiemy',
            },
            integration: {
                name: 'Poproś o integrację',
                desc: 'Twoja opinia jest dla nas bardzo cenna — zostaw krótką wiadomość',
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Dziękujemy za sugestię!',
                desc: 'Doceniamy, że poświęciłeś czas na podzielenie się opinią — pomaga nam to ulepszać produkt.'
            },
            feedback: {
                name: 'Dziękujemy za opinię!',
                desc: 'Doceniamy, że poświęciłeś czas na podzielenie się opinią — pomaga nam to ulepszać produkt.'
            },
            support: {
                name: 'Dziękujemy za kontakt!',
                desc: 'Dziękujemy za kontakt z pomocą techniczną — sprawdzimy Twoje zgłoszenie i odpowiemy najszybciej, jak to możliwe.',
            },
            bug: {
                name: 'Dziękujemy za zgłoszenie!',
                desc: 'Dziękujemy za zgłoszenie tego problemu — pomaga nam to szybciej naprawiać błędy i stale ulepszać produkt.',
            },
            contact: {
                name: 'Dziękujemy za kontakt!',
                desc: 'Otrzymaliśmy Twoją wiadomość i odpowiemy najszybciej, jak to możliwe.',
            },
            invite_people: {
                name: 'Zaproszenie zostało wysłane!',
                desc: 'Dziękujemy, że przekazujesz dalej — nie możemy się doczekać, aby ich powitać.',
            },
            integration: {
                name: 'Dziękujemy za sugestię!',
                desc: 'Doceniamy, że poświęciłeś czas na podzielenie się opinią — pomaga nam to ulepszać produkt.',
            },
        },
        m_diagram_details: {
            name_place: 'Wpisz nazwę projektu',
            desc_place: 'Wpisz opis projektu'
        },
        m_quick_share: {
            title: 'Szybkie udostępnianie',
            subtitle: '(Przez link)'
        },
        m_export_img: {
            title: 'Eksportuj obraz'
        },
        search_menu: {
            placeholder: 'Szukaj tabel, kolumn, typów...',
            hint: '',
            no_results: 'Brak wyników',
            quick_results: 'Szybkie wyniki dla',
            untitled: 'bez nazwy',
            command_tag: 'polecenie',
            section_tables: 'Tabele',
            section_columns: 'Kolumny',
            section_canvas: 'Obszar roboczy',
            section_export: 'Eksport',
            section_preferences: 'Preferencje',
            section_settings: 'Ustawienia',
            type_table: 'tabela',
            type_note: 'notatka',
            cmd_new_table: 'Utwórz nową tabelę...',
            cmd_new_note: 'Utwórz nową notatkę...',
            cmd_new_line: 'Utwórz nową linię...',
            cmd_new_area: 'Utwórz nowy obszar...',
            cmd_export_image: 'Eksportuj obraz...',
            cmd_export_sql: 'Eksportuj kod SQL...',
            cmd_grid_style: 'Zmień widok siatki...',
        },
        canvas_table: {
            more_column: 'kolumna więcej',
            more_columns: 'kolumn więcej',
            tooltip_table: 'Tabela',
            tooltip_indexes: 'Indeksy',
            tooltip_enum: 'Enum',
            tooltip_default: 'Domyślna',
            tooltip_generated: 'Generowana',
            tooltip_check: 'Check',
        },
        m_export_code: {
            title: 'Eksportuj kod {{db_engine}}',
            download_file: 'Pobierz plik',
            copy_code: 'Kopiuj kod'
        },
        m_sign_in_remind: {
            title: 'Dziękujemy za wypróbowanie DB Design',
            subtitle: 'Zaloguj się lub zarejestruj, aby zwiększyć maksymalną liczbę tabel, zapisywać diagramy i odblokować więcej funkcji.'
        },
        m_sign_in_restrict: {
            title: 'Zaloguj się, aby zrobić więcej w aplikacji',
            subtitle: 'Zaloguj się lub zarejestruj, aby zwiększyć limity tabel, zapisywać diagramy i odblokować więcej funkcji.'
        },
        m_new_diagram: {
            title: 'Nowy diagram',
            subtitle: 'Wybierz silnik bazy danych',
            open_diagram: 'Otwórz diagram',
            create_diagram: 'Utwórz diagram',
            no_workspace: 'Najpierw utwórz przestrzeń roboczą, aby rozpocząć diagram.',
            build_something_new: 'Stwórzmy coś nowego',
            create_diagram_section: 'Utwórz diagram',
            clone_template_btn: 'Duplikuj szablon',
        },
        m_diagram_name: {
            enter_new_name: 'Wpisz nową nazwę diagramu',
        },
        m_diagram_clone: {
            header: 'Duplikuj diagram',
            copy_of_title: 'Kopia {{title}}',
        },
        m_diagram_rename: {
            header: 'Zmień nazwę diagramu',
        },
        m_template_clone: {
            header: 'Utwórz diagram z szablonu',
        },
        m_diagram_delete: {
            header: 'Usuń diagram',
            desc_prefix: 'Zostanie usunięty: ',
        },
        m_diagram_archive: {
            header: 'Archiwizuj diagram',
            desc_prefix: 'Zostanie zarchiwizowany: ',
        },
        m_diagram_restore: {
            header: 'Przywróć diagram',
            desc_prefix: 'Zostanie przywrócony: ',
        },
        m_diagram_import: {
            sql_name: 'Importuj kod SQL',
            dbml_name: 'Importuj kod DBML',
            // NOTE: en.js flags this placeholder copy as mismatched content (reads like
            // feedback-modal copy, not an SQL/DBML paste prompt). Kept verbatim in
            // translation since fixing the copy is a product call, not a translation one.
            placeholder: 'Chętnie poznamy Twoją opinię!',
        },
        m_diagram_not_found: {
            header: 'Nie znaleziono diagramu',
            desc: 'Nie mogliśmy znaleźć szukanego diagramu.',
            back_to_app: 'Powrót do aplikacji',
        },
        m_diagram_share: {
            header: 'Udostępnij diagram – {{title}}',
            owner_only_invite: 'Tylko właściciel może zapraszać nowych członków',
            invited_to_workspace: 'Zaproszono do przestrzeni roboczej',
            you: 'Ty',
            email_placeholder: 'Wpisz e-mail',
            email_already_in_list: 'e-mail jest już na liście',
            will_be_invited_to_workspace: 'zostanie zaproszony do przestrzeni roboczej',
        },
        m_invite_people: {
            header: 'Zaproś do przestrzeni roboczej',
        },
        m_invite_revoke: {
            header: 'Usuń zaproszenie',
            desc_prefix: 'Usuń zaproszenie dla ',
            desc_suffix: 'Zaproszenie przestanie działać.',
        },
        m_member_remove: {
            header: 'Usuń członka',
            desc_prefix: 'Usunąć ',
            desc_suffix: ' z tej przestrzeni roboczej? Straci dostęp.',
        },
        m_template_details: {
            preview: 'Podgląd',
            use_template: 'Użyj szablonu',
        },
        m_workspace_create: {
            header: 'Utwórz nową przestrzeń roboczą',
            name_label: 'Nazwa',
            setup_config_label: 'Konfiguracja',
            setup_config_value: 'Pusta przestrzeń robocza',
            template_structure_label: 'Szablon/Struktura',
            template_structure_value: 'Wstępnie wczytaj strukturę',
            placeholder: 'Wpisz nazwę przestrzeni roboczej',
            create_button: 'Utwórz przestrzeń roboczą',
            creating: 'Tworzenie przestrzeni roboczej...',
        },
        m_workspace_delete: {
            header: 'Usuń przestrzeń roboczą',
            desc_prefix: 'Zostanie trwale usunięta: ',
            confirm_prefix: 'Wpisz ',
            confirm_suffix: ', aby potwierdzić.',
        },
        m_workspace_leave: {
            header: 'Opuść przestrzeń roboczą',
            desc_prefix: 'To usunie Cię z ',
            desc_suffix: '. Aby dołączyć ponownie, będziesz musiał zostać zaproszony.',
        },
        m_workspace_menu: {
            manage_members: 'Zarządzaj członkami',
            switch_workspace: 'Przełącz przestrzeń roboczą',
            workspaces_label: 'Przestrzenie robocze',
            create_workspace: 'Utwórz przestrzeń roboczą...',
            switching: 'Przełączanie',
        },
        m_profile_menu: {
            profile: 'Profil',
            onboarding: 'Wprowadzenie',
        },
        m_pricing_limit: {
            admin_roles: { title: 'Przenieś współpracę na wyższy poziom', description: 'Ulepsz plan, aby odblokować więcej ról udostępniania, takich jak Administrator, Edytor, Komentujący, Przeglądający.' },
            workspaces: { title: 'Szybko się rozwijasz!', description: 'Ulepsz plan, aby tworzyć i zarządzać większą liczbą przestrzeni roboczych dla swoich projektów i zespołów.' },
            workspaces_canvas: { title: 'Rozwiń swoje przestrzenie robocze', description: 'Ulepsz plan, aby tworzyć i zarządzać większą liczbą przestrzeni roboczych dla swoich projektów i zespołów.' },
            members: { title: 'Współpracuj na dużą skalę', description: 'Ulepsz plan, aby zaprosić więcej członków do swojej przestrzeni roboczej i skuteczniej współpracować.' },
            diagrams: { title: 'Szybko się rozwijasz!', description: 'Ulepsz plan, aby tworzyć więcej diagramów i pewnie rozwijać swoje projekty.' },
            tables: { title: 'Twórz bez ograniczeń', description: 'Ulepsz plan, aby dodać więcej tabel i tworzyć większe, bardziej szczegółowe diagramy.' },
            columns: { title: 'Twórz bez ograniczeń', description: 'Ulepsz plan, aby dodać więcej kolumn i tworzyć większe, bardziej szczegółowe diagramy.' },
            notes: { title: 'Twórz bez ograniczeń', description: 'Ulepsz plan, aby dodać więcej notatek i tworzyć większe, bardziej szczegółowe diagramy.' },
            areas: { title: 'Twórz bez ograniczeń', description: 'Ulepsz plan, aby dodać więcej obszarów i tworzyć większe, bardziej szczegółowe diagramy.' },
            pens: { title: 'Twórz bez ograniczeń', description: 'Ulepsz plan, aby dodać więcej rysunków i tworzyć większe, bardziej szczegółowe diagramy.' },
            default_title: 'Przenieś współpracę na wyższy poziom',
            default_title_canvas: 'Zwiększ wydajność',
        },
        m_pricing_plans: {
            title: 'Ulepsz swój plan',
            subtitle: 'Zawsze możesz później ulepszyć lub obniżyć swój plan',
            monthly: 'Miesięcznie',
            annually: 'Rocznie',
            billed_annually: 'Rozliczenie roczne',
            billed_monthly: 'Rozliczenie miesięczne',
            free_for_everyone: 'Darmowy dla wszystkich',
            current_plan: 'Aktualny plan',
            will_be_available_soon: 'Będzie dostępne wkrótce',
            price_period_user_month: '/użytkownika/miesiąc',
            plan_free: {
                name: 'Darmowy',
                button: 'Zmień plan',
                feature_realtime: 'Współpraca w czasie rzeczywistym',
                feature_members: '4 członków / przestrzeń robocza',
                feature_diagrams: '4 diagramy / przestrzeń robocza',
                feature_tables: '40 tabel / diagram',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'Wszystkie funkcje planu Darmowego +',
                feature_members: 'Nieograniczona liczba członków',
                feature_diagrams: 'Nieograniczona liczba diagramów',
                feature_tables: 'Nieograniczona liczba tabel',
                feature_history: 'Historia wersji',
                feature_admin_roles: 'Role administratora',
            },
        },
        sidebar: {
            new: 'Nowy',
            pinned_diagrams: 'Przypięte diagramy',
            pin_hint: 'Przypnij diagramy, aby zobaczyć je tutaj',
            expand_sidebar: 'Rozwiń pasek boczny',
            home_aria: 'Strona główna DB Design',
            open_menu: 'Otwórz menu',
            close_menu: 'Zamknij menu',
            sidebar_menu_aria: 'Menu paska bocznego',
            plan_suffix: 'plan',
            diagram_options: 'Opcje diagramu',
            pin: 'Przypnij',
            unpin: 'Odepnij',
            edit_details: 'Edytuj szczegóły',
            see_details: 'Zobacz szczegóły',
            invite_people: 'Zaproś osoby',
            collapse_sidebar: 'Zwiń pasek boczny',
            close_sidebar: 'Zamknij pasek boczny',
            open_sidebar: 'Otwórz pasek boczny',
            open_new_tab: 'Otwórz w nowej karcie',
        },
        focus_controls: {
            show_top: 'Pokaż górne sterowanie',
            hide_top: 'Ukryj górne sterowanie',
            show_left: 'Pokaż lewe sterowanie',
            hide_left: 'Ukryj lewe sterowanie',
        },
        m_keyboard_shortcuts: {
            title: 'Skróty klawiaturowe',
            general: {
                title1: 'Ogólne',
                title2: '',
                items: {
                    new_diagram: 'Utwórz diagram',
                    new_chat: 'Nowy czat',
                    search: 'Szybkie akcje lub wyszukiwanie',
                    preferences: 'Preferencje',
                    settings: 'Ustawienia',
                    keyboard_shortcuts: 'Skróty klawiaturowe',
                    toggle_sidebar: 'Przełącz pasek boczny',
                    toggle_theme: 'Przełącz motyw',
                },
            },
            ctrl_left: {
                title1: 'Sterowanie',
                title2: '(Lewo)',
                items: {
                    mouse_sel: 'Zaznaczanie myszą / Tryb ręki',
                    table: 'Tabela',
                    line: 'Linia',
                    area: 'Obszar',
                    note: 'Notatka',
                    comment: 'Komentarz',
                    pen: 'Ołówek',
                    undo: 'Cofnij',
                    redo: 'Ponów'
                }
            },
            ctrl_top_left: {
                title1: 'Sterowanie',
                title2: '(Lewy górny)',
                items: {
                    export_img: 'Eksportuj obraz',
                    search: 'Szukaj',
                    editor_panel: 'Panel edytora',
                    zoom_to_fit: 'Dopasuj do ekranu',
                }
            },
            ctrl_bottom_right: {
                title1: 'Sterowanie',
                title2: '(Prawy dolny)',
                items: {
                    minimap: 'Minimapa',
                    full_screen: 'Pełny ekran',
                    zoom_in: 'Powiększ',
                    zoom_out: 'Pomniejsz',
                    zoom_100: 'Zoom 100%'
                }
            },
            ctx_tab: {
                title1: 'Menu kontekstowe',
                title2: '(Tabela)',
                items: {
                    dupl_tab: 'Duplikuj tabelę',
                    del_tab: 'Usuń tabelę'
                }
            },
            ctx_del_tab: {
                title1: 'Menu kontekstowe',
                title2: '(Usuń tabelę)',
                items: {
                    yes: 'Tak',
                    no: 'Nie'
                }
            },
            ctx_tab_col: {
                title1: 'Menu kontekstowe',
                title2: '(Kolumna tabeli)',
                items: {
                    add_col_below: 'Dodaj kolumnę poniżej',
                    focus_col_above: 'Ustaw fokus na kolumnie powyżej',
                    focus_col_below: 'Ustaw fokus na kolumnie poniżej',
                    move_col_up: 'Przenieś kolumnę w górę',
                    move_col_down: 'Przenieś kolumnę w dół',
                    dupl_col: 'Duplikuj kolumnę',
                    del_col: 'Usuń kolumnę'
                }
            },
            ctx_line: {
                title1: 'Menu kontekstowe',
                title2: '(Linia)',
                items: {
                    del_line: 'Usuń linię'
                }
            },
            ctx_area: {
                title1: 'Menu kontekstowe',
                title2: '(Obszar)',
                items: {
                    dupl_area: 'Duplikuj obszar',
                    del_area: 'Usuń obszar'
                }
            },
            ctx_multi: {
                title1: 'Menu kontekstowe',
                title2: '(Wielokrotny wybór)',
                items: {
                    select_all: 'Zaznacz wszystkie elementy',
                    create_area_for_select_els: 'Utwórz obszar dla zaznaczonych elementów',
                    dupl_select_els: 'Duplikuj zaznaczone elementy',
                    del_select_els: 'Usuń zaznaczone elementy'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Zaznaczanie myszą',
                table: 'Tabela',
                line: 'Linia',
                area: 'Obszar',
                note: 'Notatka',
                comment: 'Komentarz',
                pen: 'Ołówek',
                undo: 'Cofnij',
                redo: 'Ponów'
            },
            ctrl_top_left: {
                home: 'Strona główna',
                name: 'Informacje o diagramie',
                editor: 'Edytor',
                search: 'Wyszukiwanie',
                export: 'Opcje eksportu',
                view_mode: 'Tryb widoku',
                zoom_to_fit: 'Dopasuj do ekranu',
                grid: 'Widok siatki',
                history: 'Historia',
                main_menu: 'Menu główne',
                new_diagram: 'Nowy diagram',
            },
            ctrl_top_right: {
                feature_req: 'Prośba o funkcję',
                feedback: 'Wyślij opinię',
                sign_in: 'Zaloguj się',
                quick_share: 'Szybkie udostępnianie'
            },
            ctrl_bottom_right: {
                full_screen: 'Pełny ekran',
                minimap: 'Minimapa',
                zoom_out: 'Pomniejsz',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Powiększ',
                info: 'Informacje i zasoby'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Domyślny',
                        blue: 'Niebieski',
                        green: 'Zielony',
                        red: 'Czerwony',
                        purple: 'Purpurowy',
                        violet: 'Fioletowy'
                    },
                    borders: {
                        none: 'Brak',
                        solid: 'Ciągła',
                        dashed: 'Kreskowana',
                        dotted: 'Kropkowana'
                    },
                    color: 'Kolor',
                    border: 'Obramowanie',
                    description: 'Opis',
                    description_table_place: 'Opis tabeli',
                    description_column_place: 'Opis kolumny',
                    description_line_place: 'Opis linii',
                    description_note_place: 'Opis notatki',
                    description_area_place: 'Opis obszaru',
                    description_pen_place: 'Opis ołówka',
                    hide_menu: 'Ukryj menu',
                    show_menu: 'Pokaż menu'
                },
                tab_col: {
                    add_col_below: 'Dodaj kolumnę poniżej',
                    add_col_above: 'Dodaj kolumnę powyżej',
                    key: 'Key',
                    keys: {
                        none: 'Brak',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Brak',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Przenieś kolumnę w dół',
                    move_col_up: 'Przenieś kolumnę w górę',
                    more_functions: 'Więcej funkcji'
                },
                line: {
                    change_connects: 'Zmień łączniki',
                    connects: {
                        empty: 'Puste',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Filtruj elementy'
                },
                note: {
                    link_placeholder: 'Wpisz link',
                    link_apply: 'Dodaj',
                    link_remove: 'Usuń',
                    link_edit: 'Edytuj',
                    link_needs_selection: 'Zaznacz tekst, aby dodać link',
                    bulleted_list: 'Lista',
                    numbered_list: 'Lista numerowana',
                    font_style: 'Styl czcionki',
                    alignment: 'Wyrównanie',
                    align_left: 'Do lewej',
                    align_center: 'Do środka',
                    align_right: 'Do prawej',
                    link: 'Link',
                    monospace: 'Monospace',
                    bold: 'Pogrubienie',
                    italic: 'Kursywa',
                    underline: 'Podkreślenie',
                    strikethrough: 'Przekreślenie',
                },
                multi: {
                    filter: 'Filtruj zaznaczenie',
                    create_area: 'Utwórz obszar'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Pełny',
            keys_only: 'Tylko klucze',
            names_only: 'Tylko nazwy'
        },
        dropdown_ctrl_grid: {
            none: 'Brak',
            lines: 'Linie',
            dots: 'Kropki',
        },
        dropdown_ctrl_export: {
            export_img: 'Eksportuj obraz',
            export_code: 'Eksportuj kod SQL'
        },
        dropdown_ctrl_settings: {
            back_home: 'Powrót do strony głównej',
            sign_in: 'Zaloguj się',
            preferences: 'Preferencje',
            new_project: 'Nowy projekt',
            import_diagram: 'Importuj diagram',
            duplicate_diagram: 'Duplikuj diagram',
            keyboard_shortcuts: 'Skróty klawiaturowe',
            languages: 'Języki',
            view: 'Widok',
            upgrade_plan: 'Ulepsz plan',
            language: 'Język',
            mouse_trackpad: 'Mysz lub gładzik',
            background_color: 'Kolor tła',
            grid_layout: 'Układ siatki',
            view_mode: 'Tryb widoku',
            show_align_lines: 'Pokaż linie wyrównania',
            show_members_cursors: 'Pokaż kursory członków',
            show_comments: 'Pokaż komentarze',
            undo_redo_controls: 'Sterowanie cofnij/ponów',
            show_scrollbars: 'Pokaż paski przewijania',
            opt_auto: 'Automatycznie',
            opt_trackpad: 'Gładzik',
            opt_mouse: 'Mysz',
            opt_default: 'Ciemny (domyślny)',
            opt_gray: 'Szary',
            opt_blue: 'Niebieski',
            opt_purple: 'Purpurowy',
            opt_violet: 'Fioletowy',
            opt_green: 'Zielony',
            opt_red: 'Czerwony',
            opt_yellow: 'Żółty',
            opt_dots: 'Kropki',
            opt_lines: 'Linie',
            opt_none: 'Brak',
            opt_full: 'Pełny',
            opt_keys: 'Klucze',
            opt_names: 'Nazwy',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Opinie',
            keyboard_shortcuts: 'Skróty klawiaturowe',
            languages: 'Języki',
            homepage: 'Strona główna'
        },
        n: {
            default: 'Ładowanie…',
            file_ready_to_download: 'Plik jest gotowy do pobrania',
            code_copied: 'Kod został skopiowany',
            link_copied: 'Link został skopiowany',
            username_copied: 'Nazwa użytkownika skopiowana do schowka',
            email_copied: 'E-mail skopiowany do schowka',
            please_enter_message: 'Wpisz wiadomość',
            invalid_email: 'Adres e-mail jest nieprawidłowy',
            note_link_unsupported_protocol: 'Nieobsługiwany typ linku. Użyj https, http, mailto.',
            something_wrong_contact: 'Coś poszło nie tak. Odśwież stronę lub skontaktuj się z nami.',
            something_wrong: 'Coś poszło nie tak. Odśwież stronę.',
            sending: 'Wysyłanie…',
            request_sent: 'Żądanie zostało wysłane. Dziękujemy!',

            please_enter_email: 'Wpisz adres e-mail',
            changing: 'Zmienianie...',
            role_changed: 'Rola zmieniona',
            removing: 'Usuwanie...',
            member_removed: 'Członek usunięty',
            inviting: 'Zapraszanie...',
            invite_sent: 'Zaproszenie wysłane',
            added_to_diagram: 'Dodano do diagramu',
            invite_removed: 'Zaproszenie usunięte',
            role_not_allowed_on_plan: 'Ta rola nie jest dostępna w Twoim planie. Ulepsz plan, aby ją przypisać.',
            already_diagram_member: 'Ta osoba ma już dostęp do diagramu.',
            cannot_invite_to_workspace: 'Poproś administratora przestrzeni roboczej o zaproszenie tej osoby.',
            saving: 'Zapisywanie...',
            saved: 'Zapisano',
            diagram_renamed: 'Zmieniono nazwę diagramu',
            diagram_updated: 'Diagram zaktualizowany',
            duplicating: 'Duplikowanie...',
            diagram_duplicated: 'Diagram zduplikowany',
            deleting: 'Usuwanie...',
            diagram_archived: 'Diagram zarchiwizowany',
            diagram_deleted: 'Diagram usunięty',
            restoring: 'Przywracanie...',
            diagram_restored: 'Diagram przywrócony',
            diagram_pinned: 'Diagram przypięty',
            diagram_unpinned: 'Diagram odpięty',
            creating: 'Tworzenie...',
            diagram_created: 'Diagram utworzony',
            forbidden: 'Nie masz do tego dostępu.',
            invite_already_pending: 'This person already has a pending invitation.',
            already_member: 'Już jest członkiem przestrzeni roboczej',
            cannot_invite_self: 'Nie możesz zaprosić samego siebie',
            workspace_not_found: 'Workspace not found. Refresh the page and try again.',
            diagram_not_found: 'Nie znaleziono diagramu.',
            has_diagram_members: 'Diagram ma aktywnych członków',
            seat_limit_reached: 'Osiągnięto limit miejsc w Twoim planie. Ulepsz plan, aby zaprosić więcej osób.',
            feature_not_in_plan: 'Ta funkcja nie jest dostępna w Twoim obecnym planie.',
            subscription_expired: 'Twoja subskrypcja wygasła. Odnów ją, aby dalej korzystać z tej funkcji.',
            subscription_inactive: 'Twoja subskrypcja jest nieaktywna. Zaktualizuj dane rozliczeniowe.',
            plan_limit_generic: 'Twój plan nie pozwala na tę czynność. Ulepsz plan, aby kontynuować.',

            // Auth / profile
            session_expired: 'Twoja sesja wygasła — zaloguj się ponownie.',
            profile_updated: 'Profil zaktualizowany',
            profile_update_failed: 'Nie udało się zaktualizować profilu.',
            account_delete_failed: 'Nie udało się usunąć konta.',

            // Preferences
            couldnt_save: 'Nie udało się zapisać zmian',
            try_again: 'Coś poszło nie tak. Spróbuj ponownie.',

            // Workspace
            not_workspace_member: 'Nie jesteś członkiem tej przestrzeni roboczej.',
            workspace_switch_failed: 'Nie udało się przełączyć przestrzeni roboczej. Spróbuj ponownie.',
            workspace_create_failed: 'Nie udało się utworzyć przestrzeni roboczej. Spróbuj ponownie.',
            invalid_workspace_name: 'Nieprawidłowa nazwa przestrzeni roboczej',
            workspace_updated: 'Przestrzeń robocza zaktualizowana',
            workspace_update_failed: 'Nie udało się zaktualizować przestrzeni roboczej. Spróbuj ponownie.',
            last_owner_cannot_leave: 'Jesteś jedynym właścicielem. Ustaw kogoś innego właścicielem lub usuń przestrzeń roboczą przed opuszczeniem jej.',
            workspace_leave_failed: 'Nie udało się opuścić przestrzeni roboczej. Spróbuj ponownie.',
            workspace_delete_forbidden: 'Tylko właściciel przestrzeni roboczej może ją usunąć.',
            workspace_has_active_billing: 'Anuluj subskrypcję tej przestrzeni roboczej przed jej usunięciem.',
            workspace_deleted: 'Przestrzeń robocza usunięta',
            workspace_delete_failed: 'Nie udało się usunąć przestrzeni roboczej. Spróbuj ponownie.',
            member_remove_forbidden: 'Nie masz uprawnień, aby usunąć tego członka.',
            member_remove_failed: 'Nie udało się usunąć członka. Spróbuj ponownie.',
            cannot_remove_self: 'Użyj opcji „Opuść przestrzeń roboczą”, aby usunąć samego siebie.',
            cannot_remove_last_owner: 'Przestrzeń robocza musi zawsze mieć właściciela. Najpierw ustaw kogoś innego właścicielem.',
            invite_revoke_forbidden: 'Nie masz uprawnień, aby cofnąć to zaproszenie.',
            invite_revoke_failed: 'Nie udało się cofnąć zaproszenia. Spróbuj ponownie.',
        },
        dashboard: {
            doc_title: 'Diagramy',
            filter_all: 'Wszystkie',
            filter_mydiagrams: 'Moje diagramy',
            filter_shared: 'Udostępnione mi',
            filter_archived: 'Zarchiwizowane',
            empty_all: 'Brak diagramów w "Wszystkie diagramy"',
            empty_mydiagrams: 'Brak diagramów w "Moje diagramy"',
            empty_shared: 'Brak diagramów w "Udostępnione mi"',
            empty_archived: 'Brak diagramów w "Zarchiwizowane"',
            example_diagram_badge: 'Przykładowy diagram',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'Powrót do aplikacji',
                group_personal: 'Osobiste',
                group_organization: 'Organizacja',
                billing: 'Rozliczenia',
            },
            profile: {
                member_since: 'Członek od {{date}}',
                general: 'Ogólne',
                email: 'E-mail',
                full_name: 'Imię i nazwisko',
                full_name_placeholder: 'Wpisz imię i nazwisko',
                account_protection: 'Ochrona konta',
                mfa_label: 'Uwierzytelnianie wieloskładnikowe (MFA)',
                mfa_sub: 'Dodatkowa warstwa zabezpieczeń konta · Wkrótce dostępne',
                mfa_enable: 'Włącz MFA',
                mfa_soon_tooltip: 'Wkrótce dostępne',
                workspace_access: 'Dostęp do przestrzeni roboczej',
                leave_workspace: 'Opuść przestrzeń roboczą',
                leave_workspace_sub: 'Usuń siebie z przestrzeni roboczej',
                leave_owner_tooltip: 'Przekaż własność przed opuszczeniem przestrzeni roboczej',
            },
            workspace: {
                header: 'Przestrzeń robocza',
                general: 'Ogólne',
                name_label: 'Nazwa przestrzeni roboczej',
                name_placeholder: 'nazwa przestrzeni roboczej',
                stat_member_singular: 'Członek',
                stat_member_plural: 'Członkowie',
                stat_team_singular: 'Zespół',
                stat_team_plural: 'Zespoły',
                members_section: 'Członkowie',
                no_members: 'Brak członków',
                count_member_singular: 'członek',
                count_member_plural: 'członków',
                view_members_btn: 'Zobacz członków',
                danger_zone: 'Strefa zagrożenia',
                delete_workspace: 'Usuń przestrzeń roboczą',
                delete_workspace_sub: 'To trwale usunie przestrzeń roboczą',
                delete_owner_only_tooltip: 'Tylko właściciele mogą usuwać przestrzenie robocze',
                delete_cancel_sub_tooltip: 'Anuluj subskrypcję przed usunięciem przestrzeni roboczej',
            },
            members: {
                header: 'Członkowie',
                col_name: 'Nazwa',
                col_email: 'E-mail',
                col_role: 'Rola',
                col_joined: 'Dołączył(a)',
                active_members: 'Aktywni członkowie',
                invited_section: 'Zaproszeni',
                no_members: 'Brak członków.',
                options_aria: 'Opcje',
                leave_workspace_item: 'Opuść przestrzeń roboczą...',
                remove_member_item: 'Usuń członka...',
                remove_owner_only_tooltip: 'Tylko właściciele mogą usuwać członków',
                remove_owner_row_tooltip: 'Właściciela nie można usunąć z przestrzeni roboczej',
                remove_invite_item: 'Usuń zaproszenie...',
                role_invited_suffix: '{{role}} (Zaproszony)',
            },
            preferences: {
                section_general: 'Ogólne',
                section_diagram_defaults: 'Ustawienia diagramu',
                section_diagram_views: 'Widoki diagramu',
                section_notifications: 'Powiadomienia',
                theme_label: 'Motyw interfejsu',
                theme_sub: 'Wybierz schemat kolorów interfejsu',
                theme_dark: 'Ciemny',
                theme_light: 'Jasny',
                theme_system: 'Systemowy',
                language_sub: 'Wybierz język interfejsu',
                timezone_label: 'Strefa czasowa',
                timezone_sub: 'Wybierz swoją strefę czasową',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Hawaje',
                    anchorage: 'GMT-09:00 — Alaska',
                    los_angeles: 'GMT-08:00 — Czas pacyficzny',
                    denver: 'GMT-07:00 — Czas górski',
                    chicago: 'GMT-06:00 — Czas centralny',
                    new_york: 'GMT-05:00 — Czas wschodni',
                    caracas: 'GMT-04:00 — Caracas',
                    sao_paulo: 'GMT-03:00 — São Paulo',
                    azores: 'GMT-01:00 — Azory',
                    london: 'GMT+00:00 — Londyn',
                    paris: 'GMT+01:00 — Paryż, Berlin',
                    kyiv: 'GMT+02:00 — Kijów, Ateny',
                    istanbul: 'GMT+03:00 — Stambuł',
                    dubai: 'GMT+04:00 — Dubaj',
                    karachi: 'GMT+05:00 — Karaczi',
                    kolkata: 'GMT+05:30 — Indie',
                    dhaka: 'GMT+06:00 — Dhaka',
                    bangkok: 'GMT+07:00 — Bangkok, Dżakarta',
                    shanghai: 'GMT+08:00 — Pekin, Singapur',
                    tokyo: 'GMT+09:00 — Tokio, Seul',
                    sydney: 'GMT+10:00 — Sydney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Wybierz sterowanie nawigacją po płótnie',
                background_sub: 'Wybierz kolor tła płótna',
                grid_sub: 'Wybierz układ siatki płótna',
                show_align_lines_sub: 'Pokazuj linie podczas wyrównywania obiektów',
                show_cursors_sub: 'Pokazuj kursory innych współpracowników',
                show_comments_sub: 'Pokazuj komentarze na płótnie',
                show_scrollbars_sub: 'Pokazuj paski przewijania podczas nawigacji po płótnie',
                show_undo_redo_label: 'Pokazuj elementy sterujące cofnij/ponów',
                show_undo_redo_sub: 'Pokazuj elementy sterujące do cofania i ponawiania zmian',
                notif_shared_label: 'Diagram udostępniony mi',
                notif_shared_sub: 'Gdy ktoś udostępni mi diagram',
                notif_mentions_label: 'Wzmianki w komentarzach',
                notif_mentions_sub: 'Gdy ktoś oznaczy mnie @wzmianką w komentarzu',
                notif_updates_label: 'Aktualizacje produktu',
                notif_updates_sub: 'Comiesięczne aktualizacje o nowych funkcjach i ulepszeniach',
                show: 'Pokaż',
                hide: 'Ukryj',
                on: 'Włączone',
                off: 'Wyłączone',
            },
            billing: {
                header: 'Rozliczenia',
                plan_free: 'Plan darmowy',
                status_current: 'Bieżący',
                no_renewal_needed: 'Odnowienie nie jest wymagane',
                payment_header: 'Płatność',
                no_payments: 'Brak płatności',
                invoices_header: 'Faktury',
                no_invoices: 'Brak faktur',
            },
            usage: {
                doc_title: 'Użycie',
                overview_title: 'Przegląd',
                resource_limits_title: 'Limity zasobów',
                label_diagrams: 'Diagramy',
                label_tables: 'Tabele',
                label_areas: 'Obszary',
                label_notes: 'Karteczki',
                label_members: 'Członkowie',
                label_tables_per_diagram: 'Tabele / Diagram',
                label_areas_per_diagram: 'Obszary / Diagram',
                label_notes_per_diagram: 'Notatki / Diagram',
                need_more_title: 'Potrzebujesz więcej?',
                need_more_free: 'Przejdź na plan Basic, aby uzyskać więcej diagramów, historię wersji i priorytetowe wsparcie.',
                need_more_paid: 'Przejdź na plan Professional, aby uzyskać nieograniczoną liczbę diagramów, miejsc i zaawansowane funkcje.',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'Nie znaleziono strony',
                dont_have_access_to_diagram: 'Nie masz dostępu do tego diagramu lub mógł on już nie istnieć.',
                back_home: 'Powrót do strony głównej'
            },
            error: {
                title: 'Błąd',
                link_is_invalid: 'Ten link jest nieprawidłowy lub został wprowadzony błędnie.',
                something_wrong: 'Coś poszło nie tak.',
                back_home: 'Powrót do strony głównej',
                please_try_later: 'Spróbuj ponownie później',
            },
            billing_success: {
                doc_title: 'Plan zaktualizowany',
                heading: 'Płatność zakończona sukcesem',
                subtitle: 'Twój plan został pomyślnie zaktualizowany.',
                cta: 'Zacznij projektować',
            },
            email_verified: {
                doc_title: 'E-mail zweryfikowany',
            },
            forgot_password: {
                doc_title: 'Nie pamiętam hasła',
            },
            password_updated: {
                doc_title: 'Hasło zaktualizowane',
            },
            reset_password: {
                doc_title: 'Zresetuj hasło',
            },
            check_email: {
                doc_title: 'Sprawdź swoją pocztę',
            },
            sign_in: {
                doc_title: 'Zaloguj się do {{product}}',
            },
            sign_up: {
                doc_title: 'Zarejestruj się w {{product}}',
            },
        },
    }
};

export const plMeta = {
    lang_origin: 'Polski',
    lang_eng: 'Polish',
    lang_code: 'pl',
};
